import { render, staticRenderFns } from "./ServicePermissionsModalEditForm.vue?vue&type=template&id=6e6af356&scoped=true&"
import script from "./ServicePermissionsModalEditForm.vue?vue&type=script&lang=js&"
export * from "./ServicePermissionsModalEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6af356",
  null
  
)

export default component.exports